import { makeStyles } from '@material-ui/core/styles';

export const useSubscriptionsStyles = makeStyles(theme => ({
  input: {
    display: 'flex',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    marginLeft: '15px',
    [theme.breakpoints.up(1024)]: {
      marginLeft: '80px',
    },
  },
  fields: {
    width: '100% !important',
    display: 'flex',
    justifyContent: 'space-between',
  },
  createBox: {
    maxWidth: '100%',
  },
  content: {
    maxWidth: '100%',
  },
  table: {
    width: '30%',
    minWidth: '400px',
    border: '1px solid rgb(224, 224, 224)',
    '& th': {
      padding: 5,
    },
    '& td': {
      padding: 5,
      textAlign: 'left',
      borderLeft: '1px solid rgb(224, 224, 224)',
    },
    '& button': {
      height: 20,
      marginLeft: 30,
      textAlign: 'right',
      borderLeft: '1px solid rgb(224, 224, 224)',
    },
  },
  actionButtons: {
    '& > *': {
      marginRight: '30px',
    },
  },
  dateInput: {
    minWidth: '150px',
  },
  labels: {
    fontSize: 24,
    marginTop: 4,
  },
}));
